import { ActionIcon, Grid, Group, Stack, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useMemo, useState } from "react";
import Image from "next/image";
import Link from "next/link";

const rightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="white"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.25 4.5 7.5 7.5-7.5 7.5"
    />
  </svg>
);

const leftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="rgb(245, 159, 0)"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 19.5 8.25 12l7.5-7.5"
    />
  </svg>
);

function getCardJsx(item, index, len, imagesAlt) {
  return (
    <Grid.Col span={{ base: 12, md: 6, lg: 3 }} key={index}>
      <div
        className={`shadow-md px-5 py-5 rounded-md md:h-[330px] h-[350px] ${
          index % 2 !== 0 ? "bg-nivabupa-blue-light text-white" : null
        }`}
      >
        <Link prefetch={false} href={item.link}>
          <Stack align="center">
            <img
              src={item.imgUrl}
              alt={imagesAlt}
              sizes="100vw"
              height={0}
              width={0}
              loading="lazy"
              className="h-[120px] w-full"
            />
            <Stack>
              <h2 className="text-xl font-bold">
                {item?.heading?.length > 40
                  ? item?.heading?.substring(0, 35) + "..."
                  : item?.heading}
              </h2>
              <p className="text-sm">{item.description}</p>
            </Stack>
          </Stack>
        </Link>
      </div>
    </Grid.Col>
  );
}

export default function CardSection({ cardsData, imagesAlt }) {
  const [selectedSetIndex, setSelectedSetIndex] = useState(0);
  const isMobile = !useMediaQuery("(min-width: 56.25em)");
  const numCards = isMobile ? 1 : 3;

  const handlePrevClick = () => {
    setSelectedSetIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNextClick = () => {
    setSelectedSetIndex((prevIndex) =>
      Math.min(prevIndex + 1, Math.floor(cardsData?.length / numCards) - 1)
    );
  };

  const visiblePlans = useMemo(() => {
    const startIndex = selectedSetIndex * numCards;
    const endIndex = startIndex + numCards;
    return (cardsData ?? []).slice(startIndex, endIndex);
  }, [cardsData, selectedSetIndex, isMobile]);

  return (
    <div className="my-9 w-full mx-auto max-w-[1280px]">
      <Group justify="space-between">
        <Title order={2}>You may also like</Title>
        <Group justify="flex-end" mb="xs">
          <ActionIcon
            color="yellow"
            radius="xl"
            size="xl"
            variant="default"
            onClick={handlePrevClick}
            disabled={selectedSetIndex === 0}
          >
            {leftIcon}
          </ActionIcon>
          <ActionIcon
            color="yellow"
            radius="xl"
            size="xl"
            variant="filled"
            onClick={handleNextClick}
            disabled={selectedSetIndex === cardsData?.length - 1}
          >
            {rightIcon}
          </ActionIcon>
        </Group>
      </Group>

      <Grid gutter="xl" grow>
        {visiblePlans.map((item, index, arr) => {
          return getCardJsx(item, index, arr.length, imagesAlt);
        })}
      </Grid>
    </div>
  );
}
